import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Home, ChevronRight, Users, ExternalLink, Search, Star,
  Shield, Clock, HeartHandshake, Award, Zap, MapPin,
} from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SideMenu from '../components/SideMenu';
import CookieConsent from '../components/CookieConsent';
import StickyBreadcrumb from '../components/StickyBreadcrumb';
import PrivacyPolicy from '../components/PrivacyPolicy';
import { clients } from '../mock';

const CLIENT_META = {
  1:  { category: 'Móveis & Design',        segment: 'moveis',     description: 'Loja de móveis planejados e decoração em Ribeirão Preto.',          city: 'Ribeirão Preto, SP' },
  2:  { category: 'Móveis & Design',        segment: 'moveis',     description: 'Revenda e exposição de móveis para casa e escritório.',               city: 'Ribeirão Preto, SP' },
  3:  { category: 'Automotiva',             segment: 'auto',       description: 'Especialista em funilaria e pintura automotiva de alto padrão.',      city: 'Ribeirão Preto, SP' },
  4:  { category: 'Automotiva',             segment: 'auto',       description: 'Mecânica de precisão com serviços completos de manutenção veicular.', city: 'Ribeirão Preto, SP' },
  5:  { category: 'Automotiva',             segment: 'auto',       description: 'Serviços automotivos especializados para carros e utilitários.',      city: 'Ribeirão Preto, SP' },
  6:  { category: 'Automotiva',             segment: 'auto',       description: 'Centro automotivo completo com diagnóstico computadorizado.',         city: 'Ribeirão Preto, SP' },
  7:  { category: 'Móveis & Design',        segment: 'moveis',     description: 'Móveis e artigos de decoração para ambientes residenciais.',          city: 'Ribeirão Preto, SP' },
  8:  { category: 'Móveis & Design',        segment: 'moveis',     description: 'Loja de móveis com entrega e montagem em toda a região.',             city: 'Ribeirão Preto, SP' },
  9:  { category: 'Saúde',                  segment: 'saude',      description: 'Clínica de saúde e medicina ocupacional com atendimento completo.',   city: 'Ribeirão Preto, SP' },
  10: { category: 'Transportes & Logística',segment: 'transporte', description: 'Transportadora especializada em entregas pontuais em todo o Brasil.', city: 'Ribeirão Preto, SP' },
  12: { category: 'Locação',                segment: 'locacao',    description: 'Locação de veículos, máquinas e equipamentos para empresas.',         city: 'Ribeirão Preto, SP' },
  13: { category: 'Educação & Móveis',      segment: 'moveis',     description: 'Móveis escolares e corporativos com qualidade e durabilidade.',       city: 'Ribeirão Preto, SP' },
  14: { category: 'Imobiliária',            segment: 'imoveis',    description: 'Imobiliária especializada em compra, venda e locação em Ribeirão Preto e região.', city: 'Ribeirão Preto, SP' },
  15: { category: 'Contabilidade',          segment: 'contabil',   description: 'Escritório de contabilidade especializado em consultoria contábil, fiscal e abertura de empresas.', city: 'Ribeirão Preto, SP' },
  16: { category: 'Indústria & Mecânica',   segment: 'industria',  description: 'Especialista em brunimento industrial, retífica de motores e serviços de usinagem de precisão.', city: 'Ribeirão Preto, SP' },
};

const CATEGORY_STYLE = {
  moveis:     { label: 'Móveis & Design',         bg: 'bg-amber-900/40',   text: 'text-amber-300',   border: 'border-amber-700/40'   },
  auto:       { label: 'Automotiva',              bg: 'bg-blue-900/40',    text: 'text-blue-300',    border: 'border-blue-700/40'    },
  saude:      { label: 'Saúde',                   bg: 'bg-emerald-900/40', text: 'text-emerald-300', border: 'border-emerald-700/40' },
  transporte: { label: 'Transportes & Logística', bg: 'bg-violet-900/40',  text: 'text-violet-300',  border: 'border-violet-700/40'  },
  locacao:    { label: 'Locação',                 bg: 'bg-cyan-900/40',    text: 'text-cyan-300',    border: 'border-cyan-700/40'    },
  imoveis:    { label: 'Imobiliária',             bg: 'bg-rose-900/40',    text: 'text-rose-300',    border: 'border-rose-700/40'    },
  contabil:   { label: 'Contabilidade',           bg: 'bg-indigo-900/40',  text: 'text-indigo-300',  border: 'border-indigo-700/40'  },
  industria:  { label: 'Indústria & Mecânica',    bg: 'bg-orange-900/40',  text: 'text-orange-300',  border: 'border-orange-700/40'  },
};

const SEGMENTS = ['todos', 'auto', 'moveis', 'saude', 'transporte', 'locacao', 'imoveis', 'contabil', 'industria'];

const DIFERENCIAIS = [
  { icon: <Clock className="w-6 h-6" />,         title: 'Suporte Rápido',      desc: 'Atendimento em até 4h para contratos ativos. SLA garantido por contrato.' },
  { icon: <Shield className="w-6 h-6" />,        title: 'Segurança de Dados',  desc: 'Backup automatizado, antivírus gerenciado e política de acesso controlado.' },
  { icon: <HeartHandshake className="w-6 h-6" />,title: 'Parceria de Longo Prazo', desc: 'Mais de 15 anos cuidando da TI de empresas em Ribeirão Preto e região.' },
  { icon: <Award className="w-6 h-6" />,         title: 'Equipe Especializada', desc: 'Técnicos certificados em infraestrutura, sistemas de gestão e redes.' },
  { icon: <Zap className="w-6 h-6" />,           title: 'Tecnologia Atualizada', desc: 'Soluções modernas: nuvem, câmeras IP, Wi-Fi empresarial e automação.' },
  { icon: <MapPin className="w-6 h-6" />,        title: 'Atendimento Local',    desc: 'Presença física em Ribeirão Preto — atendimento presencial e remoto.' },
];

const PAGE_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": "https://fernandotech.com.br/clientes-vip",
      "url": "https://fernandotech.com.br/clientes-vip",
      "name": "Clientes VIP — Empresas Parceiras Fernando Tech em Ribeirão Preto",
      "description": "Conheça as empresas que confiam na Fernando Tech para TI, suporte técnico e sistemas de gestão em Ribeirão Preto e região.",
      "inLanguage": "pt-BR"
    },
    {
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Home",         "item": "https://fernandotech.com.br/" },
        { "@type": "ListItem", "position": 2, "name": "Clientes VIP", "item": "https://fernandotech.com.br/clientes-vip" }
      ]
    }
  ]
};

export default function ClientesVipPage() {
  const [filter, setFilter]           = useState('todos');
  const [search, setSearch]           = useState('');
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [visible, setVisible]         = useState(false);

  useEffect(() => {
    document.title = 'Clientes VIP | Empresas Parceiras Fernando Tech — Ribeirão Preto';
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) { meta = document.createElement('meta'); meta.name = 'description'; document.head.appendChild(meta); }
    meta.content = 'Conheça os Clientes VIP da Fernando Tech em Ribeirão Preto. Empresas de móveis, automotiva, saúde, transportes e imóveis que confiam no nosso suporte de TI há mais de 15 anos.';

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
    canonical.href = 'https://fernandotech.com.br/clientes-vip';

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'ld-clientes-vip';
    script.text = JSON.stringify(PAGE_SCHEMA);
    document.head.appendChild(script);

    // Animação de entrada
    const t = setTimeout(() => setVisible(true), 80);

    return () => {
      clearTimeout(t);
      document.title = 'Fernando Tech – Suporte Técnico Premium - Ribeirão Preto e Região';
      const ldScript = document.getElementById('ld-clientes-vip');
      if (ldScript) ldScript.remove();
      const canon = document.querySelector('link[rel="canonical"]');
      if (canon) canon.href = 'https://fernandotech.com.br/';
    };
  }, []);

  const enriched = clients.map(c => ({ ...c, ...(CLIENT_META[c.id] || {}) }));

  const filtered = enriched.filter(c => {
    const matchSeg    = filter === 'todos' || c.segment === filter;
    const matchSearch = !search
      || c.name.toLowerCase().includes(search.toLowerCase())
      || (c.description || '').toLowerCase().includes(search.toLowerCase());
    return matchSeg && matchSearch;
  });

  return (
    <div className="bg-slate-950 min-h-screen">
      <Navbar />

      {/* Breadcrumb — fixed logo abaixo da Navbar (mantém visível no scroll) */}
      <StickyBreadcrumb>
        <nav className="flex items-center gap-1.5 text-sm text-slate-500" aria-label="Breadcrumb">
          <Link to="/" className="flex items-center gap-1 hover:text-cyan-400 transition-colors">
            <Home className="w-3.5 h-3.5" /> Home
          </Link>
          <ChevronRight className="w-3.5 h-3.5 text-slate-700" />
          <span className="flex items-center gap-1 text-cyan-400">
            <Users className="w-3.5 h-3.5" /> Clientes VIP
          </span>
        </nav>
      </StickyBreadcrumb>

      {/* ── Hero ──────────────────────────────────────────────────────── */}
      <section className="py-16 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute -top-20 -left-20 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl" />
          <div className="absolute -bottom-10 -right-10 w-80 h-80 bg-blue-500/5 rounded-full blur-3xl" />
        </div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-cyan-500/10 border border-cyan-500/30 rounded-full text-cyan-400 text-sm font-semibold mb-5">
            <Star className="w-3.5 h-3.5 fill-cyan-400" /> Parceiros de Confiança
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-5 leading-tight">
            Clientes VIP<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400">
              Fernando Tech
            </span>
          </h1>

          <p className="text-slate-400 text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
            Empresas de Ribeirão Preto e região que crescem com suporte de TI profissional,
            sistemas ERP e soluções tecnológicas há mais de 15 anos.
          </p>

          {/* Stats */}
          <div className="flex flex-wrap justify-center gap-8 mb-2">
            {[
              { value: '15+',  label: 'Empresas Parceiras' },
              { value: '15+',  label: 'Anos de Mercado'    },
              { value: '8',    label: 'Segmentos'          },
              { value: '100%', label: 'Satisfação'         },
            ].map(s => (
              <div key={s.label} className="text-center">
                <div className="text-3xl font-extrabold text-cyan-400 tabular-nums">{s.value}</div>
                <div className="text-slate-500 text-sm mt-0.5">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Por que escolhem a Fernando Tech ─────────────────────────── */}
      <section className="py-14 bg-slate-900/40 border-y border-slate-800/60">
        <div className="container mx-auto px-4">
          <p className="text-xs font-bold uppercase tracking-widest text-cyan-400 text-center mb-3">
            Diferenciais
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold text-white text-center mb-10">
            Por que empresas escolhem a Fernando Tech?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {DIFERENCIAIS.map((d, i) => (
              <div
                key={d.title}
                className="flex gap-4 p-5 bg-slate-800/50 border border-slate-700/50 rounded-2xl hover:border-cyan-500/30 transition-all"
                style={{
                  opacity:   visible ? 1 : 0,
                  transform: visible ? 'translateY(0)' : 'translateY(16px)',
                  transition: `opacity 0.4s ease ${i * 0.07}s, transform 0.4s ease ${i * 0.07}s`,
                }}
              >
                <div className="shrink-0 w-11 h-11 rounded-xl bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center text-cyan-400">
                  {d.icon}
                </div>
                <div>
                  <p className="text-white font-semibold text-sm mb-1">{d.title}</p>
                  <p className="text-slate-500 text-xs leading-relaxed">{d.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Filtros + Busca ───────────────────────────────────────────── */}
      <section className="py-5 bg-slate-900/60 border-b border-slate-800 sticky top-[120px] z-30 backdrop-blur-md">
        <div className="container mx-auto px-4">
          <div className="flex flex-col sm:flex-row items-center gap-3">
            {/* Busca */}
            <div className="relative w-full sm:max-w-xs">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
              <input
                type="text"
                placeholder="Buscar empresa..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                className="w-full bg-slate-800/70 border border-slate-700 hover:border-cyan-500/40 focus:border-cyan-500 text-white placeholder-slate-500 rounded-full pl-10 pr-4 py-2 text-sm outline-none transition-colors"
                data-testid="client-search-input"
              />
            </div>

            {/* Filtros */}
            <div className="flex flex-wrap gap-2 justify-center sm:justify-start">
              {SEGMENTS.map(seg => {
                const style    = CATEGORY_STYLE[seg] || {};
                const isActive = filter === seg;
                const count    = seg === 'todos' ? enriched.length : enriched.filter(c => c.segment === seg).length;
                return (
                  <button
                    key={seg}
                    onClick={() => setFilter(seg)}
                    className={`px-3.5 py-1.5 rounded-full text-xs font-semibold border transition-all ${
                      isActive
                        ? 'bg-cyan-600 border-cyan-500 text-white shadow-md shadow-cyan-500/20 scale-105'
                        : `${style.bg || 'bg-slate-800/60'} ${style.border || 'border-slate-700'} ${style.text || 'text-slate-400'} hover:scale-105 hover:border-cyan-500/40`
                    }`}
                    data-testid={`filter-${seg}`}
                  >
                    {seg === 'todos' ? `Todos` : (style.label || seg)}
                    <span className={`ml-1.5 text-[10px] font-normal ${isActive ? 'text-cyan-200' : 'opacity-60'}`}>
                      ({count})
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* ── Grid de Clientes ─────────────────────────────────────────── */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          {filtered.length === 0 ? (
            <div className="text-center py-20 text-slate-500">
              <Users className="w-14 h-14 mx-auto mb-4 opacity-20" />
              <p className="text-lg font-medium">Nenhum cliente encontrado</p>
              <p className="text-sm mt-1">Tente outro termo ou segmento</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
              {filtered.map((client, i) => {
                const segStyle = CATEGORY_STYLE[client.segment] || CATEGORY_STYLE.auto;
                return (
                  <article
                    key={client.id}
                    className="group bg-slate-900/70 border border-slate-800 hover:border-cyan-500/40 rounded-2xl overflow-hidden flex flex-col hover:shadow-xl hover:shadow-cyan-500/8"
                    style={{
                      opacity:   visible ? 1 : 0,
                      transform: visible ? 'translateY(0)' : 'translateY(20px)',
                      transition: `opacity 0.4s ease ${0.05 + i * 0.04}s, transform 0.4s ease ${0.05 + i * 0.04}s, box-shadow 0.3s ease, border-color 0.3s ease`,
                    }}
                    itemScope itemType="https://schema.org/LocalBusiness"
                  >
                    {/* Logo */}
                    <div className="bg-white rounded-t-2xl flex items-center justify-center h-32 p-4 overflow-hidden relative">
                      <img
                        src={client.logo}
                        alt={client.seoAlt || client.name}
                        title={client.seoTitle || client.name}
                        className="max-h-20 max-w-full object-contain transition-transform duration-300 group-hover:scale-105"
                        loading="lazy"
                        itemProp="image"
                        onError={e => { e.target.style.display = 'none'; }}
                      />
                      {/* Badge de segmento sobre o logo */}
                      <span className={`absolute top-2 right-2 text-[10px] font-bold px-2 py-0.5 rounded-full border ${segStyle.bg} ${segStyle.text} ${segStyle.border}`}>
                        {client.category}
                      </span>
                    </div>

                    {/* Info */}
                    <div className="p-4 flex flex-col flex-1 gap-2">
                      <h2 className="text-white font-bold text-base leading-tight" itemProp="name">
                        {client.name}
                      </h2>
                      <p className="text-slate-500 text-xs leading-relaxed flex-1" itemProp="description">
                        {client.description}
                      </p>
                      <div className="text-slate-600 text-xs flex items-center gap-1">
                        <MapPin className="w-3 h-3 shrink-0" />
                        <span itemProp="address">{client.city}</span>
                      </div>
                      {client.website && (
                        (() => {
                          const isWhats = /wa\.me|whatsapp/i.test(client.website);
                          return (
                            <a
                              href={client.website}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={`mt-1 flex items-center justify-center gap-1.5 py-2 px-4 ${
                                isWhats
                                  ? 'bg-emerald-900/40 hover:bg-emerald-700/60 border-emerald-600/50 hover:border-emerald-400 text-emerald-300 hover:text-emerald-100'
                                  : 'bg-slate-800 hover:bg-cyan-900/40 border-slate-700 hover:border-cyan-500/50 text-slate-400 hover:text-cyan-300'
                              } border rounded-xl text-xs font-medium transition-all`}
                              itemProp="url"
                              data-testid={`client-link-${client.id}`}
                            >
                              {isWhats ? (
                                <>
                                  <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.122 1.533 5.85L0 24l6.338-1.497A11.93 11.93 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.789 9.789 0 01-4.99-1.364l-.358-.213-3.76.888.937-3.647-.234-.374A9.786 9.786 0 012.182 12C2.182 6.57 6.57 2.182 12 2.182c5.43 0 9.818 4.388 9.818 9.818 0 5.43-4.388 9.818-9.818 9.818z"/></svg>
                                  Falar no WhatsApp
                                </>
                              ) : (
                                <>
                                  <ExternalLink className="w-3.5 h-3.5" /> Visitar Site
                                </>
                              )}
                            </a>
                          );
                        })()
                      )}
                    </div>
                  </article>
                );
              })}
            </div>
          )}

          <p className="text-center text-slate-600 text-sm mt-10">
            Exibindo <span className="text-slate-400 font-semibold">{filtered.length}</span> de{' '}
            <span className="text-slate-400 font-semibold">{enriched.length}</span> empresas parceiras
          </p>
        </div>
      </section>

      {/* ── CTA ───────────────────────────────────────────────────────── */}
      <section className="py-16 bg-gradient-to-br from-slate-900 via-blue-950/30 to-slate-900 border-t border-slate-800 relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-48 bg-cyan-500/5 rounded-full blur-3xl" />
        </div>
        <div className="container mx-auto px-4 text-center relative z-10 max-w-2xl">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-cyan-500/10 border border-cyan-500/30 rounded-full text-cyan-400 text-sm font-semibold mb-5">
            <Users className="w-3.5 h-3.5" /> Seja o próximo cliente VIP
          </div>
          <h2 className="text-white font-extrabold text-2xl sm:text-3xl mb-3 leading-tight">
            Sua empresa também pode ter suporte de TI de alto nível
          </h2>
          <p className="text-slate-400 text-sm mb-8 leading-relaxed">
            Mais de 15 empresas em Ribeirão Preto confiam na Fernando Tech para manter a tecnologia
            funcionando. Atendimento rápido, equipe especializada e soluções sob medida para o seu negócio.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://wa.me/5516991378312?text=Olá!%20Gostaria%20de%20conhecer%20os%20serviços%20de%20TI%20da%20Fernando%20Tech%20para%20minha%20empresa."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-emerald-600 hover:bg-emerald-700 text-white font-bold rounded-full shadow-lg shadow-emerald-500/20 transition-all hover:scale-105 text-sm"
              data-testid="cta-whatsapp-clients"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.122 1.533 5.85L0 24l6.338-1.497A11.93 11.93 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.789 9.789 0 01-4.99-1.364l-.358-.213-3.76.888.937-3.647-.234-.374A9.786 9.786 0 012.182 12C2.182 6.57 6.57 2.182 12 2.182c5.43 0 9.818 4.388 9.818 9.818 0 5.43-4.388 9.818-9.818 9.818z"/></svg>
              Falar pelo WhatsApp
            </a>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-slate-800 hover:bg-slate-700 border border-slate-600 hover:border-slate-500 text-white font-bold rounded-full transition-all hover:scale-105 text-sm"
              data-testid="cta-home-clients"
            >
              Ver todos os serviços
            </Link>
          </div>
        </div>
      </section>

      <Footer onOpenPrivacyPolicy={() => setShowPrivacy(true)} />
      <SideMenu />
      <CookieConsent onOpenPrivacyPolicy={() => setShowPrivacy(true)} />
      <PrivacyPolicy isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} />
    </div>
  );
}
